
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(1(107|545|796|980)|5190|7345|7875)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
